import {Injectable} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {Location} from '../../types/location.type';
import unit = Location.unit;
import {HelperService} from '../helper/helper.service';

@Injectable({
  providedIn: 'root'
})
export class LocationsFormatterService {

  constructor(private translateService: TranslateService, private helperService: HelperService) {
  }

  getLocationDeviceType(location: Location.serverSide | any): string {
    if (!location) {
      return null;
    }
    if (location.device_type) {
      return location.device_type.type;
    }
    if (location.deviceType) {
      return location.deviceType;
    }
    return null;
  }

  public getAllLocationsFlat(locations: any[], resultLocations: any[] = []) {
    const result = resultLocations;
    for (const child of locations) {
      const childs = (<Location.clientSide>child).child || (<Location.serverSide>child).children;
      result.push(child);
      if (!!childs) {
        this.getAllLocationsFlat(childs, result);
      }
    }
    return result;
  }

  public setTreeLocationUnit(units: any[], locId: number, selected: boolean, type: string, children: any[] = [], showThermalCorrection = false): unit[] {
    let unitArray: any[] = [];
    if (children.length === 0) {
      units.forEach((unit) => {
        if (unit) {
          unitArray.push(this.setUnitForLocationTree(unit, locId, selected));
          if (showThermalCorrection) {
            unitArray.push(this.setUnitForLocationTree(unit + 'CT', locId, selected));
          }
          if (showThermalCorrection) {
            unitArray.push(this.setUnitForLocationTree('TEMPERATURE', locId, selected));
          }
        } else {
          if (type === 'liris_v2' || type === 'liris_v3' || type === 'ext_v3') {
            unitArray.push(this.setUnitForLocationTree('MICRODEF', locId, selected));
            if (showThermalCorrection) {
              unitArray.push(this.setUnitForLocationTree('MICRODEFCT', locId, selected));
            }
            unitArray.push(this.setUnitForLocationTree('TEMPERATURE', locId, selected));
          }
          if (type === 'inclino_v2' || type === 'inclino_v3') {
            unitArray.push(this.setUnitForLocationTree('RADIAN', locId, selected));
            unitArray.push(this.setUnitForLocationTree('TEMPERATURE', locId, selected));
          }

          if (type === 'inclinobiaxis_v2') {
            unitArray.push(this.setUnitForLocationTree('RADIAN-X', locId, selected));
            unitArray.push(this.setUnitForLocationTree('RADIAN-Y', locId, selected));
            unitArray.push(this.setUnitForLocationTree('TEMPERATURE', locId, selected));
          }

          if (type === 'exteg' || type === 'expe') {
            unitArray.push(this.setUnitForLocationTree('MILLIMETER', locId, selected));
            unitArray.push(this.setUnitForLocationTree('TEMPERATURE', locId, selected));
          }

          if (type === 'optic_v5') {
            unitArray.push(this.setUnitForLocationTree('MICRODEF', locId, selected));
            if (showThermalCorrection) {
              unitArray.push(this.setUnitForLocationTree('MICRODEFCT', locId, selected));
            }
            if (showThermalCorrection) {
              unitArray.push(this.setUnitForLocationTree('TEMPERATURE', locId, selected));
            }
          }

          if (type === 'pt_v5') {
            unitArray.push(this.setUnitForLocationTree('TEMPERATURE', locId, selected));
          }
        }
      });
    }
    return unitArray;
  }

  private setUnitForLocationTree(unit: string, locId: number, selected: boolean) {
    return {
      value: this.translateService.instant(unit),
      unit: unit,
      color: this.helperService.getColor(unit, locId),
      selected: selected
    };
  }

}
